export default "__VITE_ASSET__DWdhYJEE__"